import { render, staticRenderFns } from "./GroupOperateColumn.vue?vue&type=template&id=0151dd1e&scoped=true&"
import script from "./GroupOperateColumn.vue?vue&type=script&lang=js&"
export * from "./GroupOperateColumn.vue?vue&type=script&lang=js&"
import style0 from "./GroupOperateColumn.vue?vue&type=style&index=0&id=0151dd1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0151dd1e",
  null
  
)

export default component.exports